
<template>
  <view class="blue">
    <text>Timer</text>
    <button>时间</button>
  </view>
</template>

<script>
import { View, Text, Button } from '@tarojs/components'
export default {
  name: 'TimerComponent',
  components: {
    View,
    Text,
    Button
  }
}
</script>